import { useMemo } from "react";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useMobileMenu } from "@shared/features/mobileMenu/useMobileMenu";
import { ProgramMeetingInformationDialog } from "./ProgramMeetingInformationDialog";
import { useUserCircle } from "@platform/hooks/useUserCircle";
import { useUserTimezoneOption } from "@platform/hooks/useUserTimezoneOption";

export function ProgramMeetingInformationContainer() {
  const { activeDialog, closeDialog, dialogProps } = useDialog();

  const { closeMobileMenu } = useMobileMenu();

  const isOpen = activeDialog === "meetingInformation";

  const meetingId = dialogProps?.meetingId;

  const circle = useUserCircle();

  const userTimezoneOption = useUserTimezoneOption();

  const handleDone = async () => {
    // close the dialog
    closeDialog("meetingInformation");

    closeMobileMenu();
  };

  const circleWithMarkedMeeting = useMemo(() => {
    if (!circle) return null;
    return {
      ...circle,
      meetings: circle.meetings.map((meeting) =>
        meeting.id === meetingId ? { ...meeting, isSelected: true } : meeting
      ),
    };
  }, [circle, meetingId]);

  if (!userTimezoneOption) return null;
  if (!circleWithMarkedMeeting) return null;

  return (
    <ProgramMeetingInformationDialog
      circle={circleWithMarkedMeeting}
      userTimezoneOption={userTimezoneOption}
      onClose={handleDone}
      isOpen={isOpen}
    />
  );
}

export default ProgramMeetingInformationContainer;
